import type { Wishlist, WishlistItem } from './types'

export const toWishlist = (attributes: Wishlist) => ({
  id: attributes?.id,
  name: attributes?.name,
  wishlistItems: (attributes?.wishlistItems ?? []).map(toWishlistItem),
  createdAt: attributes?.createdAt,
  /**
   * @deprecated removed without replacement
   */
  type: undefined,
  /**
   * @deprecated removed without replacement
   */
  numberOfItems: undefined,
  /**
   * @deprecated removed without replacement
   */
  updatedAt: undefined,
  /**
   * @deprecated removed without replacement
   */
  links: undefined,
  /**
   * @deprecated removed without replacement
   */
  relationshipNames: undefined,
})

export const toWishlistItem = (attributes: WishlistItem) => ({
  id: attributes.id,
  /**
   * @deprecated removed without replacement
   */
  type: undefined,
  /**
   * @deprecated removed without replacement
   */
  sku: undefined,
})
